import { render, staticRenderFns } from "./UserAgentInfo.vue?vue&type=template&id=5a35d961&scoped=true"
import script from "./UserAgentInfo.vue?vue&type=script&lang=js"
export * from "./UserAgentInfo.vue?vue&type=script&lang=js"
import style0 from "./UserAgentInfo.vue?vue&type=style&index=0&id=5a35d961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35d961",
  null
  
)

export default component.exports